import { useSelector } from 'react-redux';
import classes from './PortalHeader.module.css';

export default function PortalHeader() {
  const { texts } = useSelector((state) => state.translate);

  return (
    <header className={classes.Header}>
      <span className={classes.Title}>{texts.portalTeachingAssistantTitle}</span>
    </header>
  );
}
